/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PuzzleIconSvg from './icon-puzzle.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PuzzleIconSvg {...validProps} />;
}
SvgComponent.iconName = 'puzzleIcon';

export const PuzzleIcon = svgIconWrapper(SvgComponent);
